export const getErrorCode = (state) => state.errorStatus.code;
export const getErrorMessage = (state) => state.errorStatus.message;
export const getErrorRetry = (state) => state.errorStatus.retryAction;
